var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"action-text"},[(!!_vm.icon)?_c('icon',{staticClass:"action-icon",attrs:{"icon":_vm.icon}}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }